var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNonDemandReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.102011 12.5854C-0.135544 12.9583 0.0681776 13.5643 0.441308 13.5643H1.52687L1.52663 19.7628C1.52663 20.0892 1.69628 20.322 1.9336 20.322H3.18857C3.42613 20.322 3.59554 20.0889 3.59554 19.7628L3.59578 13.5643H4.68133C5.05447 13.5643 5.25794 13.0051 5.02063 12.5854L2.91766 8.95014C2.74801 8.67056 2.40895 8.67056 2.23932 8.95014L0.102011 12.5854Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.898 16.4771C30.1355 16.1042 29.9318 15.4982 29.5587 15.4982H28.4731L28.4734 9.29963C28.4734 8.97323 28.3037 8.74046 28.0664 8.74046H26.8114C26.5739 8.74046 26.4045 8.97356 26.4045 9.29963L26.4042 15.4982H25.3187C24.9455 15.4982 24.7421 16.0573 24.9794 16.4771L27.0823 20.1123C27.252 20.3919 27.591 20.3919 27.7607 20.1123L29.898 16.4771Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7C10.5118 7 6.86298 10.6488 6.86298 15.137C6.86298 19.6252 10.5118 23.274 15 23.274C19.4882 23.274 23.137 19.6252 23.137 15.137C23.137 10.6488 19.4882 7 15 7ZM17.9635 12.3105H16.2505C16.4732 12.6188 16.6273 12.9786 16.713 13.3554H17.9635V14.5888L16.713 14.5887C16.4389 15.8906 15.2741 16.8671 13.8866 16.8671H13.5953L16.8501 20.1733L15.0343 20.1734L12.0365 17.1412V15.5652H13.8866C14.5547 15.5652 15.12 15.1541 15.3598 14.5887H12.0365V13.3553H15.3598C15.12 12.7729 14.5547 12.3788 13.8866 12.3788L12.0365 12.379V11.0771H17.9465V12.3105L17.9635 12.3105Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonDemandReceipt);
export default __webpack_public_path__ + "static/media/NonDemandReceipt.77faad81b00deeaa0a0272c3f786c6cd.svg";
export { ForwardRef as ReactComponent };